import type { ProductHit } from '@libs/algolia';
import type { Nullable } from '@libs/core';

export type TreatsLoginLocation =
    | 'Login Pop-Up Window'
    | 'Login Page'
    | 'Checkout';

export enum Tile6UpVariant {
    PROMO = 'Promo',
    SHOPPABLE = 'Shoppable',
}

export type Tile6UpClickProps = {
    variant: string;
    name: string;
    position: number | null;
    navigationClick: string | null;
};

export type CardClick = {
    variant: string;
    title?: string;
    cardName?: string;
    cardPosition: number;
    link?: string;
    promoType?: string;
    pathname?: string | null;
    linkText?: string;
};

export type ContentfulClickProps = {
    position?: number;
    linkText: string;
    linkUrl: string;
    promoTitle: string;
    promoVariant: string;
    promoOrigin?: string | null;
    promoDesc: string;
    promoType: string;
};

export type ProductTileClickParams = {
    product: ProductHit;
    variant?: Nullable<string>;
    list?: Nullable<string>;
    position?: Nullable<number>;
};

export type TrackProductListFilterProps = {
    position: number;
    linkUrl: string;
    linkText: string;
    promoTitle: string;
    promoVariant: string;
    filterSelection: string;
    filterType: string;
    results: number;
};

export type UserAuthenticationParams = {
    totalTreatsPoints: number;
    loyaltyId: string;
    storeId: Nullable<string>;
    loginState: boolean;
};

export type TilesClickParams = {
    variant: string;
    header: string;
    title: string;
    position: number;
    row: number;
};

export type SearchFlyoutClickParams = {
    term: string;
    header: string;
    url: string;
};

export type VisualNavigationClicksParams = {
    categoryId: string;
    navPos: number;
    text: string;
};

export type EEImpressionParams = {
    products: ProductHit[];
    list: string;
};

export enum PageType {
    PDP = 'pdp',
    PLD = 'pld',
    CART = 'cart',
    CHECKOUT = 'checkout',
    HOMEPAGE = 'homepage',
    FEATURE_PAGE = 'feature page',
    ACCOUNT = 'My Account',
}

export type PageViewParams = {
    platform: 'commercetools' | 'sfcc' | null;
    page_type: PageType;

    login_status: boolean;
    loyalty_id: string;
    email: string;
    treats_points: string; // amount of points user has
    treats_tier: string;

    // @see https://petsmart.atlassian.net/wiki/spaces/DPT1/pages/1180139599/Order+History+Details+Page+Data+Layer
    page_section: string;
    page_sub_section: string;
    page_location: string;
    page_title: string;
    page_referrer: string;
    cart_id: string | undefined;
    autoship_customer?: boolean | null;
};

export interface CartItem {
    name: string;
    id: string;
    price: number;
    brand: string | undefined;
    dimension18: string | null;
    dimension19: string | null;
    dimension20: string | null;
    quantity: number;
    dimension5: string;
    dimension21: number | null;
    dimension13: number | null;
    dimension14: number | null;
    dimension12: string;
    dimension39: string;
    dimension41: string | null;
    dimension133: string;
    dimension42: string | null;
    dimension43: string | null;
    dimension44: string | null;
    dimension45: string | null;
    metric4?: number;
    metric5?: number;
}
